var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: {
        enterClass: _vm.$style.fadeUpEnter,
        enterActiveClass: _vm.$style.fadeUpEnterActive,
        leaveActiveClass: _vm.$style.fadeUpLeaveActive,
        leaveToClass: _vm.$style.fadeUpLeaveTo,
      },
    },
    [
      _vm.message || _vm.$slots.default
        ? _c(
            "div",
            {
              class: [
                _vm.$style[_vm.type],
                _vm.$style.loginAlert,
                _vm.alignClass,
              ],
            },
            [
              !_vm.centered
                ? _c("div", { class: _vm.$style.iconContainer }, [
                    _c("i", { class: [_vm.iconClass, _vm.$style.alertIcon] }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.$slots.default
                ? _c("div", [
                    _vm._v("\n      " + _vm._s(_vm.message) + "\n    "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default"),
              _vm._v(" "),
              _c(
                "button",
                {
                  class: _vm.$style.removeButton,
                  attrs: { id: "dismissAlert" },
                  on: { click: _vm.handleDismiss },
                },
                [_c("i", { class: ["jc-times-circle", _vm.$style.removeIcon] })]
              ),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }